import Text, { TextType } from "components/Text";
import { InternationalRegulation } from "../types";
import * as theme from "lib/styles/theme";
import { ReactElement } from "react";
import { TextAndShapesPalette } from "lib/styles/colors";
import SelectivelyHighlightedText from "components/SelectivelyHighlightedText";
import styled from "styled-components";

interface Props {
  capAndLimitations: InternationalRegulation[];
  searchTerm?: string;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 40px;
`;

const Header = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.colors.textAndShapes.InputField};
  padding-bottom: 8px;
`;

const RegulationItem = styled.div`
  display: flex;
  border-bottom: 0.5px solid ${theme.colors.textAndShapes.InputField};
  padding: 8px 0;
`;

export default function InternationalRegulations({
  capAndLimitations,
  searchTerm,
}: Props): ReactElement {
  if (!capAndLimitations ?? capAndLimitations.length === 0) {
    return <Text type={TextType.TITLE_1}>none</Text>;
  }
  return (
    <Container>
      <Header>
        <Text type={TextType.TITLE_2} fontColor={TextAndShapesPalette.INPUT}>
          Regulations
        </Text>
      </Header>
      {capAndLimitations.map((item) => {
        return (
          <RegulationItem key={item.refId}>
            <SelectivelyHighlightedText
              text={item.regulation}
              searchTerm={searchTerm}
            />
          </RegulationItem>
        );
      })}
    </Container>
  );
}
